import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import FormGroup from "@mui/material/FormGroup";
import Typography from "@mui/material/Typography";
//Limitless imports
import { useManagerProfileContext } from "../../../../manager/hooks";
import { useSettingsDrawer } from "@limitless/common/hooks";
import Checkbox from "../../form-elements/check-box/Checkbox";
const useStyles = makeStyles({
  itemStyle: {
    width: "85%",
    margin: "5px auto"
  }
});
const ManagerHeaderItem = ({
  profileKey,
  label,
  description
}) => {
  const {
    updateBooleanProperty,
    managerProfile
  } = useManagerProfileContext();
  const {
    toggleSettingsDrawer
  } = useSettingsDrawer();
  const classes = useStyles();
  const handleChange = () => {
    updateBooleanProperty(profileKey, !managerProfile[profileKey]);
    toggleSettingsDrawer();
  };
  return /*#__PURE__*/React.createElement(FormGroup, {
    column: "true",
    className: classes.itemStyle
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: managerProfile[profileKey],
    label: label,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, description));
};
export default ManagerHeaderItem;
ManagerHeaderItem.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  profileKey: PropTypes.string.isRequired
};